import { Badge } from "./ui/badge";
import { ESTADOS_EMPRESA } from "../lib/format";

const STYLES = {
  activa: "bg-emerald-500/10 text-emerald-700 border-emerald-300",
  pendiente_verificacion: "bg-amber-500/10 text-amber-700 border-amber-300",
  suspendida: "bg-orange-500/10 text-orange-700 border-orange-300",
  rechazada: "bg-rose-500/10 text-rose-700 border-rose-300",
  ok: "bg-emerald-500/10 text-emerald-700 border-emerald-300",
  fallido: "bg-rose-500/10 text-rose-700 border-rose-300",
  bloqueado: "bg-rose-500/10 text-rose-700 border-rose-300",
  denegado: "bg-amber-500/10 text-amber-700 border-amber-300",
  no_encontrado: "bg-amber-500/10 text-amber-700 border-amber-300",
  rechazado: "bg-rose-500/10 text-rose-700 border-rose-300",
};

export const StatusBadge = ({ value, label, testId }) => (
  <Badge variant="outline" data-testid={testId} className={`font-medium ${STYLES[value] || "bg-slate-100 text-slate-700"}`}>
    {label || ESTADOS_EMPRESA[value] || value}
  </Badge>
);
